import LockTableMouseEventsHandlerState from "./LockTableMouseEventsHandlerState";
import NullTableRegion from "../table/NullTableRegion";

export default class LockTableCellSelectionState extends LockTableMouseEventsHandlerState {
    constructor(mouseEventsHandler) {
        super(mouseEventsHandler);
    }

    mouseOver(evt, cell) {
        // refine columns if we have a row header cell
        if (cell.getColIdx() == 0)
            cell = cell.getRow().getCell(1);

        var mouseEventsHandler = this.mouseEventsHandler;

        return cell.getRow().accept(
            {
                computeAndSetSelection(cell2) {
                    var cell1 = mouseEventsHandler.getSelectionController().getSelectionAnchor();
                    var lowerCell = (cell1.getRow().getRowIdx() > cell2.getRow().getRowIdx()) ? cell1 : cell2;

                    if (lowerCell.getRow().getChildRows().length > 0) {
                        lowerCell = lowerCell.getRow().getLastChildRow().getCell(lowerCell.getColIdx());
                    }
                    mouseEventsHandler.getSelectionController().changeSelectionTo(lowerCell);
                },

                visitUserRow(cell) {
                    this.computeAndSetSelection(cell);
                },

                visitDetailsRow(cell) {
                    this.computeAndSetSelection(cell.getRow().getParentRow().getCell(cell.getColIdx()));
                },

                visitDatesRow(cell) {
                    cell = cell.getRow().getTable().getCell(cell.getRow().getRowIdx() + 1, cell.getColIdx());
                    cell.getRow().accept(this, cell);
                },

                visitRunnerRow(cell) {
                    cell = cell.getRow().getTable().getCell(cell.getRow().getRowIdx() + 2, cell.getColIdx());
                    cell.getRow().accept(this, cell);
                },

                visitInactiveRow(cell) {
                    var anchor = mouseEventsHandler.getSelectionController().getSelectionAnchor();
                    var rowIdx = cell.getRow().getRowIdx() +
                                 ( anchor.getRow().getRowIdx() > cell.getRow().getRowIdx() ? 1 : -1 );
                    mouseEventsHandler.mouseOver(evt, cell.getRow().getTable().getCell(rowIdx, cell.getColIdx()));
                }
            },
            cell
        );
    }

    mouseUp(evt, cell) {
        var selection = this.mouseEventsHandler.getSelectionController().getSelection();
        if (selection == null || selection == NullTableRegion) {
            var userCell;

            if (cell) {
                userCell = cell.getRow().accept(
                    {
                        visitUserRow(cell) { return cell; },
                        visitDetailsRow(cell) { return cell.getRow().getParentRow().getCell(cell.getColIdx()); },
                        visitDatesRow(cell) { return null; },
                        visitRunnerRow(cell) { return null; },
                        visitInactiveRow(cell) { return null; }
                    },
                    cell
                );
            }
            else {
                userCell = this.mouseEventsHandler.getSelectionController().getSelectionAnchor();
            }

            if (userCell != null) {
                var lastDetailsRow = userCell.getRow().getLastChildRow();
                if (lastDetailsRow != null)
                    cell = lastDetailsRow.getCell(userCell.getColIdx());
                else
                    cell = userCell;

                this.mouseEventsHandler.getSelectionController().changeSelectionTo(cell);
                this.mouseEventsHandler.setRangeSelectedState();
                cell.getRow().getTable().fireUserCellClicked(userCell);
            }
        }
        else {
            this.mouseEventsHandler.setRangeSelectedState();
            this.mouseEventsHandler.fireSelectionFinished(evt);
        }
    }

    mouseMove(evt, cell) {
        if (Ext.isIE && window.event && window.event.button == 0) {
            this.mouseEventsHandler.getSelectionController().clearSelection();
            this.mouseEventsHandler.setHoverState();
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/LockTableCellSelectionState.js